<div mat-dialog-title class="ds">
  <span>{{ touchpoint.subject }} <span class="type-badge">({{ typeLabel }})</span></span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close aria-label="Close">
    <ds-icon class="close-icon" icon="close" iconStyle="material-icons-outlined"></ds-icon>
  </button>
</div>

<div mat-dialog-content class="content ds">
  <div class="dialog-body">
    <div class="detail-row">
      <ds-icon class="row-icon" icon="schedule" iconStyle="material-icons-outlined"></ds-icon>
      <span>{{ formattedDateTime }}</span>
    </div>

    <ds-divider></ds-divider>

    @if (touchpoint.isRecurring) {
      <div class="detail-row">
        <ds-icon class="row-icon" icon="repeat" iconStyle="material-icons-outlined"></ds-icon>
        <span>{{ recurrenceLabel }}</span>
      </div>

      <ds-divider></ds-divider>
    }

    @if (touchpoint.location) {
      <div class="detail-row">
        <ds-icon icon="location_on" iconStyle="material-icons-outlined"></ds-icon>
        <span>{{ touchpoint.location }}</span>
      </div>

      <ds-divider></ds-divider>
    }


    @if (!isOutlookOnly && accountName) {
      <div class="detail-row">
        <ds-icon icon="business" iconStyle="material-icons-outlined"></ds-icon>
        @if (accountDashboardUrl) {
          <ds-link id="touchpoint-account-link" class="dark-link" [linkRef]="accountDashboardUrl" (click)="onAccountNameClick($event)">{{ accountName }}</ds-link>
        } @else {
          <span>{{ accountName }}</span>
        }
      </div>

      <ds-divider></ds-divider>
    }

    @if (contactNames.length) {
      <div class="detail-row">
        <ds-icon icon="group" iconStyle="material-icons-outlined"></ds-icon>
        <div class="contact-chips">
          @for (name of contactNames; track name) {
            <ds-chip variant="filled" size="small">{{ name }}</ds-chip>
          }
        </div>
      </div>

      <ds-divider></ds-divider>
    }


    @if (touchpoint.notes) {
      <div class="detail-row">
        <ds-icon icon="description" iconStyle="material-icons-outlined"></ds-icon>
        <div class="detail-content">
          <typography variant="mat-caption-1" weight="bold" class="detail-label">{{ appStrings.label_body }}</typography>
          <p class="notes-text" [innerHTML]="notesHtml"></p>
        </div>
      </div>
    }

    @if (attachments.length) {
      <ds-divider></ds-divider>

      <div class="detail-row">
        <ds-icon icon="attach_file" iconStyle="material-icons-outlined"></ds-icon>
        <div class="attachment-list">
          @for (attachment of attachments; track attachment.id) {
            <div class="attachment-row">
              <span class="attachment-name">{{ attachment.name }}</span>
              @if (attachment.size) {
                <span class="attachment-size">({{ attachment.size | fileSize }})</span>
              }
            </div>
          }
        </div>
      </div>
    }

    @if (touchpointNotes.length || isLoadingNotes) {
      <ds-divider></ds-divider>

      <div class="detail-row">
        <ds-icon icon="chat" iconStyle="material-icons-outlined"></ds-icon>
        <div class="comment-list">
          <typography variant="mat-caption-1" weight="bold" class="detail-label">{{ appStrings.label_notes }}</typography>
          @for (note of touchpointNotes; track note.id) {
            <div class="comment-row">
              <typography variant="mat-caption-1" weight="bold" class="comment-row-text">{{ note.name }} - {{ note.date | date:dateTimeFormat }}</typography>
              <typography variant="mat-body-2" weight="regular" class="comment-row-text">{{ note.detail }}</typography>
            </div>
          }
          @if (isLoadingNotes) {
            <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
          }
        </div>
      </div>
    }
  </div>
</div>

<div mat-dialog-actions align="end" class="ds dialog-actions">
  <div *appIsDesktop class="dialog-btn-wrapper">
    @if (touchpoint.isRecurring) {
      <ds-button type="secondary" variant="label-icon" label="Delete" icon="arrow_drop_down" iconPosition="right"
                [matMenuTriggerFor]="deleteMenu" size="medium">
      </ds-button>
      <mat-menu #deleteMenu="matMenu" class="ds">
        <button mat-menu-item class="touchpoint-menu-item" (click)="onDeleteThisTouchpoint()">
          This touchpoint
        </button>
        <button mat-menu-item class="touchpoint-menu-item" (click)="onDeleteThisTouchpoint(true)">
          All touchpoints in this series
        </button>
      </mat-menu>
    } @else {
      <ds-button type="secondary" variant="label-only" label="Delete" size="medium"
                 (onClick)="onDeleteThisTouchpoint()">
      </ds-button>
    }

    @if (!isArchived) {
      @if (touchpoint.isRecurring) {
        <ds-button type="secondary" variant="label-icon" label="Edit" icon="arrow_drop_down" iconPosition="right"
                   [matMenuTriggerFor]="editMenu" size="medium">
        </ds-button>
        <mat-menu #editMenu="matMenu" class="ds">
          <button mat-menu-item class="touchpoint-menu-item" (click)="onEditThisTouchpoint()">
            This touchpoint
          </button>
          <button mat-menu-item class="touchpoint-menu-item" (click)="onEditThisTouchpoint(true)">
            All touchpoints in this series
          </button>
        </mat-menu>
      } @else {
        <ds-button type="secondary" variant="label-only" label="Edit" size="medium"
                   (onClick)="onEditThisTouchpoint()">
        </ds-button>
      }
    }

    @if (showLastVisited) {
      <ds-button id="touchpointLastVisitedButton" type="secondary" variant="label-only" size="medium"
                 [label]="appStrings.label_notes" (onClick)="onLastVisited()">
      </ds-button>
    }

    @if (touchpoint.joinUrl) {
      <div class="join-split-button">
        <ds-button type="primary" variant="label-icon" label="Join" icon="videocam" iconStyle="material-icons-outlined"
                   iconPosition="left" size="medium" (onClick)="onJoinMeeting()">
        </ds-button>
        <ds-button type="primary" variant="icon-only" icon="arrow_drop_down" size="medium"
                   [matMenuTriggerFor]="joinMenu">
        </ds-button>
      </div>
      <mat-menu #joinMenu="matMenu" class="ds touchpoint-join-menu">
        <button mat-menu-item class="touchpoint-menu-item" (click)="onJoinMeeting()">
          <ds-icon icon="video_call" iconStyle="material-icons-outlined"></ds-icon>
          Join meeting
        </button>
        <button mat-menu-item class="touchpoint-menu-item" (click)="onCopyMeetingLink()">
          <ds-icon icon="link" iconStyle="material-icons-outlined"></ds-icon>
          Copy meeting link
        </button>
      </mat-menu>
    }
  </div>

  <div *appIsMobile class="mobile dialog-btn-wrapper">
    @if (isArchived) {
      @if (touchpoint.isRecurring) {
        <ds-button type="secondary" variant="label-icon" label="Delete" icon="arrow_drop_down" iconPosition="right"
                   [matMenuTriggerFor]="deleteMenuMobile" size="medium">
        </ds-button>
        <mat-menu #deleteMenuMobile="matMenu" class="ds">
          <button mat-menu-item class="touchpoint-menu-item" (click)="onDeleteThisTouchpoint()">
            This touchpoint
          </button>
          <button mat-menu-item class="touchpoint-menu-item" (click)="onDeleteThisTouchpoint(true)">
            All touchpoints in this series
          </button>
        </mat-menu>
      } @else {
        <ds-button type="secondary" variant="label-only" label="Delete" size="medium"
                   (onClick)="onDeleteThisTouchpoint()">
        </ds-button>
      }
    } @else if (touchpoint.isRecurring) {
      <ds-button type="secondary" variant="label-icon" label="Edit" icon="arrow_drop_down" iconPosition="right"
                 [matMenuTriggerFor]="combinedEditMenu" size="medium">
      </ds-button>
      <mat-menu #combinedEditMenu="matMenu" class="ds">
        <button mat-menu-item class="touchpoint-menu-item" (click)="onEditThisTouchpoint()">
          This touchpoint
        </button>
        <button mat-menu-item class="touchpoint-menu-item" (click)="onEditThisTouchpoint(true)">
          All touchpoints in this series
        </button>
        <button mat-menu-item class="touchpoint-menu-item" (click)="onDeleteThisTouchpoint()">
          {{ appStrings.touchpoints_deleteThisTouchpoint }}
        </button>
        <button mat-menu-item class="touchpoint-menu-item" (click)="onDeleteThisTouchpoint(true)">
          {{ appStrings.touchpoints_deleteAllInSeries }}
        </button>
      </mat-menu>
    } @else {
      <ds-button type="secondary" variant="label-only" label="Edit" size="medium"
                 (onClick)="onEditThisTouchpoint()">
      </ds-button>
      <ds-button type="secondary" variant="label-only" label="Delete" size="medium"
                 (onClick)="onDeleteThisTouchpoint()">
      </ds-button>
    }

    @if (showLastVisited) {
      <ds-button id="touchpointLastVisitedButtonMobile" type="secondary" variant="label-only" size="medium"
                 [label]="appStrings.label_notes" (onClick)="onLastVisited()">
      </ds-button>
    }

    @if (showCallButton) {
      <ds-button type="secondary" variant="label-icon" [label]="appStrings.button_call" icon="call"
                 iconStyle="material-icons-outlined" iconPosition="left" size="medium" (onClick)="onCall()">
      </ds-button>
    }

    @if (touchpoint.joinUrl) {
      <div class="join-split-button">
        <ds-button type="primary" variant="label-icon" label="Join" icon="videocam" iconStyle="material-icons-outlined"
                   iconPosition="left" size="medium" (onClick)="onJoinMeeting()">
        </ds-button>
        <ds-button type="primary" variant="icon-only" icon="arrow_drop_down" size="medium"
                   [matMenuTriggerFor]="joinMenuMobile">
        </ds-button>
      </div>
      <mat-menu #joinMenuMobile="matMenu" class="ds touchpoint-join-menu">
        <button mat-menu-item class="touchpoint-menu-item" (click)="onJoinMeeting()">
          <ds-icon icon="video_call" iconStyle="material-icons-outlined"></ds-icon>
          Join meeting
        </button>
        <button mat-menu-item class="touchpoint-menu-item" (click)="onCopyMeetingLink()">
          <ds-icon icon="link" iconStyle="material-icons-outlined"></ds-icon>
          Copy meeting link
        </button>
      </mat-menu>
    }
  </div>
</div>

@if (isLoading) {
  <div id="loadingContainer" class="overlay full">
    <p class="text-center">{{ appStrings.pleaseWait }}</p>
    <ds-progress-spinner progress_mode="indeterminate"></ds-progress-spinner>
  </div>
}

<ds-dialog
  id="deleteTouchpointConfirmDialog"
  [title]="appStrings.touchpoints_deleteTouchpointTitle"
  [description]="appStrings.touchpoints_deleteDescription"
  [actionButtons]="deleteDialogButtons"
  [open]="deleteDialogOpen$">
</ds-dialog>